// ts-prune-ignore-next-line
export { default } from './PageLayout';
